import { Typography } from '@material-ui/core';
import { observer } from 'mobx-react';
import React from 'react';

import { Spinner } from '../../../components/spinner';
import { ApiError } from '../../../core/api/api-error';
import { ConnectApiErrorResponseDto } from '../../../core/api/dtos';
import { injectTSDI } from '../../../core/common/tsdi';
import { I18n } from '../../../core/i18n';
import { ContractWithdrawalStore } from '../contract-withdrawal-store';
import { WithdrawalSuccessPage } from './withdrawal-success-page';

interface WithdrawalSuccessPageContainerProps {
    showOnlySuccess?: boolean;
}

export const WithdrawalSuccessPageContainer = observer(
    (props: WithdrawalSuccessPageContainerProps) => {
        const { translate } = injectTSDI(I18n);
        const { withdrawContractRequest } = injectTSDI(ContractWithdrawalStore);

        if (props.showOnlySuccess) {
            return withdrawContractRequest.match({
                fetched: (contract) => (
                    <WithdrawalSuccessPage contract={contract} />
                ),
                default: () => <></>
            });
        }

        return withdrawContractRequest.match({
            loading: () => <Spinner />,
            error: (e: ApiError) => {
                let errorMessage = e.message;
                const errors = e.errorMessages as ConnectApiErrorResponseDto[];
                if (
                    errors &&
                    errors.some((error) =>
                        error?.errorCodes.includes('SERVER_ERROR')
                    )
                ) {
                    errorMessage = translate(
                        'public.content.withdraw.contract.error'
                    );
                }
                return <Typography color="error">{errorMessage}</Typography>;
            },
            default: () => <></>
        });
    }
);
